import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const AboutSection = () => {
  const milestones = [{
    year: '2022',
    achievement: 'Company Founded'
  }, {
    year: '2024',
    achievement: 'Launched First Residential Project'
  }, {
    year: '2024',
    achievement: 'Expanded to Commercial Development'
  }];
  const values = [{
    title: 'Quality',
    description: 'We never compromise on the quality of our developments'
  }, {
    title: 'Innovation',
    description: 'Embracing new technologies and design philosophies'
  }, {
    title: 'Trust',
    description: 'Building lasting relationships with our clients and partners'
  }, {
    title: 'Sustainability',
    description: 'Creating eco-friendly spaces for future generations'
  }];
  return <section id="about" className="py-20 bg-white" data-id="element-96">
      <div className="container mx-auto px-4 lg:px-8" data-id="element-97">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-99">
            About Swastik Infra Developer
          </h2>
          <div className="w-20 h-1 bg-blue-800 mx-auto mb-6" data-id="element-100"></div>
          <p className="max-w-3xl mx-auto text-gray-600 text-lg" data-id="element-101">
            Building excellence through innovation, quality, and customer
            satisfaction since 2022.
          </p>
        </div>
        {/* Vision & Mission */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20" data-id="element-102">
          <div className="bg-gray-50 p-8 rounded-lg shadow-sm" data-id="element-103">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-104">
              Our Vision
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-105">
              To be the most trusted name in real estate development, creating
              landmark properties that enhance the quality of life and
              contribute to sustainable urban development.
            </p>
            <div className="space-y-3" data-id="element-106">
              {values.slice(0, 2).map((value, index) => <div key={index} className="flex items-start" data-id="element-107">
                  <CheckCircleIcon className="h-5 w-5 text-blue-800 mt-0.5 mr-2 flex-shrink-0" data-id="element-108" />
                  <div data-id="element-109">
                    <h4 className="font-medium text-gray-900" data-id="element-110">{value.title}</h4>
                    <p className="text-sm text-gray-600" data-id="element-111">{value.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg shadow-sm" data-id="element-112">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-113">
              Our Mission
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-114">
              To create exceptional living and working spaces through innovative
              design, superior craftsmanship, and unwavering commitment to
              customer satisfaction.
            </p>
            <div className="space-y-3" data-id="element-115">
              {values.slice(2).map((value, index) => <div key={index} className="flex items-start" data-id="element-116">
                  <CheckCircleIcon className="h-5 w-5 text-blue-800 mt-0.5 mr-2 flex-shrink-0" data-id="element-117" />
                  <div data-id="element-118">
                    <h4 className="font-medium text-gray-900" data-id="element-119">{value.title}</h4>
                    <p className="text-sm text-gray-600" data-id="element-120">{value.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        {/* Milestones */}
        <div data-id="element-121">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10" data-id="element-122">
            Our Journey
          </h3>
          <div className="relative" data-id="element-123">
            {/* Timeline Line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-100" data-id="element-124"></div>
            {/* Timeline Items */}
            <div className="space-y-12 md:space-y-0" data-id="element-125">
              {milestones.map((milestone, index) => <div key={index} className="relative md:flex items-center justify-between" data-id="element-126">
                  {/* Left side (even) or right side (odd) content */}
                  <div className={`md:w-5/12 mb-8 md:mb-0 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:order-last md:text-left md:pl-12'}`} data-id="element-127">
                    <h4 className="text-xl font-bold text-gray-900" data-id="element-128">
                      {milestone.year}
                    </h4>
                    <p className="text-gray-600" data-id="element-129">{milestone.achievement}</p>
                  </div>
                  {/* Timeline dot */}
                  <div className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 rounded-full bg-blue-800 border-4 border-white" data-id="element-130"></div>
                  {/* Right side (even) or left side (odd) - empty space for alignment */}
                  <div className={`md:w-5/12 ${index % 2 === 0 ? 'md:order-last' : ''}`} data-id="element-131"></div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default AboutSection;